import { makeStyles } from '@fluentui/react-components';

export const useCSATBySpaceTypeChartStyles = makeStyles({
  root: {
    width: '100%',
  },
});
